import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { signOut, fetchUserAttributes } from 'aws-amplify/auth';
import { useUser } from "../../UserContext";

const styles = {
    container: 'mb-2',
    mobileMenuButton: 'block xs:hidden mx-4 xs:mx-6',
    mobileMenuContainer: 'fixed top-0 right-0 bg-charmPurple border border-gray-300 p-4 flex flex-col w-full h-full transition-transform duration-300',
    closeButton: 'text-white self-end text-lg xl:text-xl font-semibold py-2',
    menuButtonContainer: 'w-full flex items-center justify-center',
    menuButton: 'w-fit text-white text-lg xl:text-xl font-semibold py-2 hover:border-b-4 border-link',
    dropdownContainer: 'fixed top-0 right-0 bg-white border border-gray-300 p-4 flex flex-col w-[25rem] h-40 z-50',
    vendorInfo: 'font-bold text-2xl',
    accountButtonContainer: 'mt-6 flex flex-row justify-start',
    accountButton: 'text-white text-lg xl:text-xl px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full mr-5',
    signOutButton: 'text-white text-lg xl:text-xl px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full',
    desktopMenuContainer: 'sm:flex flex-row mx-4 xs:mx-6 gap-4 xs:gap-12 justify-between items-center',
    profileIcon: 'h-[28px] xs:h-[36px] transform hover:scale-125 transition-transform duration-100',
    notificationsDropdownContainer: 'absolute top-0 right-0 bg-white border border-gray-300 p-4 flex flex-col w-[20rem] max-h-[15rem] overflow-y-auto z-50 shadow-lg',
    notificationItem: 'text-sm text-gray-700 py-2 px-1 hover:bg-gray-100 cursor-pointer border-b-[0.5px] border-gray-200 last:border-b-0',
    notificationButton: 'relative text-gray-600 hover:text-gray-800',
    notificationIcon: 'w-5 h-5',
};

const VendorProfileDropdown = () => {
    const navigate = useNavigate();
    const dropdownRef = useRef(null);
    const notificationsRef = useRef(null);
    const { isSignedIn, setIsSignedIn, user } = useUser();
    const [vendorEmail, setVendorEmail] = useState('');
    const [vendorId, setVendorId] = useState('');
    const [vendorName, setVendorName] = useState('');
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const checkUser = async () => {
            try {
                const userAttributes = await fetchUserAttributes();
                setVendorName(user['company_name']);
                setVendorId(userAttributes['custom:vendorId']);
                setVendorEmail(userAttributes['email']);
            } catch (error) {
            }
        };
        checkUser();
    }, []);

    const handleSignOut = async () => {
        try {
            await signOut();
            setIsSignedIn(false);
            navigate('/vendors');
        } catch (error) {
        }
    };

    const handleClickOutside = (event) => {
        if (
            dropdownRef.current && !dropdownRef.current.contains(event.target) &&
            notificationsRef.current && !notificationsRef.current.contains(event.target)
        ) {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const getInitials = (name) => {
        const names = name.split(" ");
        const initials = names.map((n) => n[0]).join("");
        return initials.toUpperCase();
    };

    return (
        <div className="">
            {isSignedIn && (
                <div className="flex items-center">
                    <div className={styles.desktopMenuContainer}>
                        <button
                            onClick={() => setIsVisible(!isVisible)}
                            className="w-10 h-10 rounded-full border-[1px] vendor-name-border text-xl text-[#9A016A] font-bold flex items-center justify-center bg-white"
                        >
                            {getInitials(vendorName)}
                        </button>
                    </div>

                    {isVisible && (
                        <div ref={dropdownRef} className="fixed top-0 right-0 bg-white border border-gray-300 p-3 flex flex-col w-[25rem] h-fit z-50">
                            <div className="w-full flex flex-row items-center justify-between gap-[16px]">
                                <p className="font-proximanova text-[18px] text-[#505050] mb-0" style={{ lineHeight: '1.2' }}>Vendor ID: #{vendorId}</p>
                            </div>
                            <button className="absolute top-3 right-3 w-[30px] h-[30px] text-[#505050] hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full flex items-center justify-center font-proximanova text-[18px] text-[#505050] rounded-full border-[1px] border-[#d1d5dc] mb-0" onClick={() => setIsVisible(false)}>X</button>
                            <p className="font-proximanova font-[700] text-[24px] text-[#505050] mb-0" style={{ lineHeight: '1.2' }}>{vendorName}</p>
                            <p className="font-proximanova text-[18px] text-[#505050] mb-0" style={{ lineHeight: '1.2' }}>{vendorEmail}</p>
                            <div className='flex flex-row justify-center gap-[32px]'>
                                <button className="mt-[8px] w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4" onClick={() => navigate("/vendors/profile/self")}>My Profile</button>
                                <button className="mt-[8px] w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4" onClick={handleSignOut}>Sign Out</button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default VendorProfileDropdown;
